import type { ChargerTileState } from "../../types/charger";

function healthLabel(health: ChargerTileState["health"]): string {
  if (health === "ok") return "OK";
  if (health === "unknown") return "OK (new)";
  return "Stale";
}

export function chargerTooltip(state: ChargerTileState): string {
  const yesNo = (v: boolean) => (v ? "yes" : "no");
  const lines = [
    state.label,
    `Health: ${healthLabel(state.health)}`,
    `Paused: ${yesNo(state.evConnected)}`,
    `Charging: ${yesNo(state.charging)}`,
    `MV5: ${yesNo(state.mv5)}`,
    `LB: ${yesNo(state.fcrActivated)}`,
    `SP: ${yesNo(state.sp)}`,
    `Resp: ${yesNo(state.resp)}`,
  ];
  if (state.powerGauge != null) {
    const { current, max } = state.powerGauge;
    const maxLabel = max != null && max > 0 ? `${max}` : "?";
    lines.push(
      `Power: ${current > 0 ? `${current}/${maxLabel}` : max != null && max > 0 ? `0/${max}` : "0"} kW`,
    );
  }
  return lines.join(" · ");
}
